import { FC } from "react";
import { Box, Link, Typography } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Replenishment } from "../../../../../types";
import { StatusBar } from "../../../../../ui/atoms/StatusBar";
import LaunchIcon from "@mui/icons-material/Launch";

interface ReplenishmentItemProps {
  replenishment: Replenishment;
  gridTemplateColumns?: string;
}

export const ReplenishmentItem: FC<ReplenishmentItemProps> = ({
  replenishment,
  gridTemplateColumns = "1fr",
}) => {
  return (
    <>
      <Box
        sx={{
          height: "40px",
          borderBottom: "1px solid #e0e0e0",
          display: { xs: "none", sm: "none", md: "grid" },
          gridTemplateColumns: gridTemplateColumns,
          px: "24px",
          paddingBottom: "8px",
          paddingTop: "8px",
          background: "#fff",
          "&:hover": {
            background: "#f5f5f5",
          },
          "&:active": {
            background: "#f5f5f5",
          },
          "&:last-child": {
            borderBottom: "none",
            borderRadius: "0 0 16px 16px",
            mb: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",

            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          <Typography
            sx={{
              width: "80%",
              overflow: "hidden",
              color: "#666666",
            }}
          >
            {replenishment.id || "-"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",
            minWidth: "160px",
            maxWidth: "160px",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          <Typography
            sx={{
              overflow: "hidden",
              color: "#666666",
            }}
          >
            {new Date(replenishment.created_at).toLocaleDateString() || "-"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <Typography
            sx={{
              color: "#666666",
            }}
          >
            {replenishment.type || "-"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100px",
          }}
        >
          <Typography
            sx={{
              color: "#666666",
              maxWidth: "100px",
            }}
          >
            ${replenishment.amount || "-"}
          </Typography>
        </Box>
        <StatusBar status={replenishment.status} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: "8px",
            whiteSpace: "nowrap",
          }}
        >
          {replenishment.url ? (
            <Link
              sx={{
                display: "flex",
                alignItems: "center",
              }}
              href={replenishment.url}
              color="rgb(25, 118, 210)"
            >
              <LaunchIcon />
            </Link>
          ) : (
            "-"
          )}
        </Box>
      </Box>
      <Box
        sx={{
          height: "80px",
          borderBottom: "1px solid #e0e0e0",
          display: { xs: "flex", sm: "flex", md: "none" },
          flexDirection: "column",
          px: "12px",
          paddingBottom: "8px",
          paddingTop: "8px",
          background: "#fff",
          "&:hover": {
            background: "#f5f5f5",
          },
          "&:active": {
            background: "#f5f5f5",
          },
          "&:last-child": {
            borderBottom: "none",
            borderRadius: "0 0 16px 16px",
            mb: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1.2fr 1.2fr 1fr",
            alignItems: "center",
            justifyContent: "space-between",
            mt: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            <Typography
              sx={{
                width: "80%",
                overflow: "hidden",
                color: "#666666",
              }}
            >
              ID:{replenishment.id || "-"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",

              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <Typography
              sx={{
                color: "#666666",
              }}
            >
              {replenishment.type || "-"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              mr: "8px",
            }}
          >
            {replenishment.url ? (
              <Link
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                href={replenishment.url}
                color="rgb(25, 118, 210)"
              >
                <LaunchIcon />
              </Link>
            ) : (
              "-"
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1.2fr 1.2fr 1fr",
            alignItems: "center",
            justifyContent: "space-between",
            mt: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <Typography
              sx={{
                color: "#666666",
              }}
            >
              {new Date(replenishment.created_at).toLocaleDateString()}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",

              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            <AttachMoneyIcon sx={{ color: "#666666" }} />
            <Typography
              sx={{
                width: "80%",
                overflow: "hidden",
                color: "#666666",
              }}
            >
              {replenishment.amount || "-"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <StatusBar status={replenishment.status} />
          </Box>
        </Box>
      </Box>
    </>
  );
};
